import React from "react";
import SharedAllVariablesPage from "~/areas/projects/components/Variables/AllVariables/SharedAllVariablesPage";
export function BranchAllVariablesPage() {
    return <SharedAllVariablesPage />;
}
